import React, { useEffect, useState } from "react";
import {
	ButtonSave,
	Checkbox,
	ContainerDash,
	Icon,
	ProfilePicture,
	Return,
} from "../../../styles/global";
import ReturnIcon from "../../../assets/icons/back_page.svg";
import Perfil from "../../../assets/icons/perfil.svg";
import CheckboxIcon from "../../../assets/icons/checkbox.svg";
import { DashBoardActions } from "../../../store/ducks/dashboard";
import { P2Desk, P3Desk, S1Desk } from "../../../styles/styles_text";
import { useDispatch, useSelector } from "react-redux";
import { PacientesProps } from "../../../interfaces/pacientes.interface";
import styled from "styled-components";
import { RelatorioActions } from "../../../store/ducks/relatorios";
import { ExecucaoProps } from "../../../interfaces/execucao.interface";
import { AssimetriaPros } from "../../../interfaces/assimetria.interface";
import { AnotacaoProps } from "../../../interfaces/anotacoes.interface";
import { TextsProps } from "../../../database/txt.interface";
import { CircularProgress } from "@material-ui/core";
import moment from "moment";
import Print from "../../../assets/kinologyIcons/svg/print.svg";
import { useDataSubscription } from "../../../hooks/useDataSubscription";
import { Colors } from "../../../styles/colors";

interface typeKeys {
	key: string;
	title: string;
	isValid: boolean;
}

interface typeKeys {
	key: string;
	title: string;
}

const EmissaoRelatorios: React.FC = () => {
	const dispatch = useDispatch();

	const patient: PacientesProps = useSelector(
		(state: any) => state.app.is_open_paciente
	);

	const current_selected_reports = useSelector(
		(state: any) => state.relatorios.current_selected_reports
	);
	const emit_type_report = useSelector(
		(state: any) => state.relatorios.emit_type_report
	);
	const current_language: TextsProps = useSelector(
		(state: any) => state.configs.current_language
	);

	const historico_anamenses = useSelector(
		(state: any) => state.anamnese.historico_anamnese
	);
	const dataReport = useSelector(
		(state: any) => state.avaliation.data_report_EVA
	);
	const dataReportPalmarGrip: any = useSelector(
		(state: any) => state.dashboard.palmar_gripe_data
	);
	//Verifica se está disponivel para emissão

	const { registredUnifiedReport, selectedService } = useDataSubscription(
		"uni_complete_report"
	);

	const reportHasLimit =
		selectedService?.value !== "unlimited" &&
		selectedService?.value !== undefined &&
		Number(selectedService?.value) > 0;

	const checkLimitReport = () => {
		const reportRest = Number(selectedService?.value) - registredUnifiedReport;
		if (selectedService?.value === "unlimited") {
			return "ilimitado";
		} else {
			return `${reportRest} restantes`;
		}
	};

	function verifyExecutions() {
		const execucoes: ExecucaoProps[] = useSelector(
			(state: any) => state.dashboard.execucoes
		);

		return execucoes.length > 0 ? true : false;
	}

	function verifyAssimetrys() {
		const assimetrias: AssimetriaPros[] = useSelector(
			(state: any) => state.dashboard.assimetria
		);

		return assimetrias.length > 0 ? true : false;
	}
	function verifyAnamneses() {
		return historico_anamenses?.anamneses.length > 0 ||
			historico_anamenses?.exames_fisio_clinico.length > 0
			? true
			: false;
	}
	function verifyAnotations() {
		const todasAnotacoes: any = useSelector(
			(state: any) => state.dashboard.anotacoes
		);

		const data = todasAnotacoes.filter(
			(filterAnotacoes: AnotacaoProps) =>
				filterAnotacoes.ID_USUARIO == patient.ID_USUARIO
		);

		return data.length > 0 ? true : false;
	}
	function verifyQualityOfLife() {
		return historico_anamenses?.sf36.length > 0 ? true : false;
	}

	function verifyDesequilibrio() {
		const desequilibrios_object: any = useSelector(
			(state: any) => state.dashboard.desequilibrio
		);

		const desequilibrios_array: any =
			(!!desequilibrios_object && Object.values(desequilibrios_object)) || 0;
		return desequilibrios_array.length > 0 ? true : false;
	}

	function verifyPrensaoPalmar() {
		// const assimetrias: AssimetriaPros[] = useSelector(
		// 	(state: any) => state.dashboard.assimetria
		// );
		// const assimetria: any = assimetrias.filter(
		// 	(ass) => ass?.ID_USUARIO == patient?.ID_USUARIO,
		// );
		// if(assimetrias.length > 0 && !!assimetria[0]?.LISTAS) {
		// 	const verifyPalm = assimetria[0]?.LISTAS['SUPERIOR_FRONTAL'].filter((exer: any) => exer?.ID_EXERCICIO === 6100 ).length > 0
		// 	return verifyPalm;
		// } else {
		// 	return false
		// }
		if (dataReportPalmarGrip?.preensao_palmar?.indicativo_saude?.resultado) {
			return true;
		} else {
			return false;
		}
	}

	const [all_reports, set_all_reports] = useState(true);
	const [loading, setLoading] = useState(false);

	const categorias_relatorios: Array<typeKeys> = [
		{
			key: "ANAMNESE",
			title: "Anamnese Completa",
			isValid: verifyAnamneses(),
		},
		{
			key: "ATENDIMENTO",
			title: "Evolução do Paciente",
			isValid: verifyAnotations(),
		},
		{
			key: "QUALIDADE_DE_VIDA",
			title: "Qualidade de Vida (SF-36)",
			isValid: verifyQualityOfLife(),
		},
		{
			key: "ASSIMETRIA",
			title: "Assimetria e Indicativos de Risco (Assimetria)",
			isValid: verifyAssimetrys(),
		},
		{
			key: "EQUILIBRIO_MUSCULAR",
			title: "Histórico de Desequilíbrio Muscular (Índice I/Q)",
			isValid: verifyDesequilibrio(),
		},
		{
			key: "PROGRESSAO_FORCA",
			title: "Histórico de Força e Valores de Referência (Evolução)",
			isValid: verifyExecutions(),
		},
		{
			key: "CURVAS_FORCA",
			title: "Dinâmica de Força e Desempenho Muscular (Força-Tempo)",
			isValid: verifyExecutions(),
		},
		{
			key: "EVA",
			title: current_language?.mapa_dor_indicativo_fibromialgia,
			isValid:
				dataReport?.eva_corpo?.atual?.length > 0 ||
				(dataReport?.eva_corpo?.anterior?.length > 0 && true) ||
				false,
		},
		{
			key: "PREENSAO_PALMAR",
			title: "Prensão Palmar",
			isValid: verifyPrensaoPalmar(),
		},
	];
	const filterOptionsForSelect =
		emit_type_report === "EVA"
			? categorias_relatorios.filter((item) => item.key == "EVA")
			: categorias_relatorios;

	function AddReportSelected(categoria: string) {
		set_all_reports(false);
		let aux_current_selected_reports = current_selected_reports;

		const exists = current_selected_reports.includes(categoria);

		if (exists) {
			aux_current_selected_reports = aux_current_selected_reports.filter(
				(key: string) => key != categoria
			);
		} else {
			aux_current_selected_reports = [
				...aux_current_selected_reports,
				categoria,
			];
		}

		dispatch(
			RelatorioActions.set_current_selected_reports(
				aux_current_selected_reports
			)
		);
	}

	useEffect(() => {
		if (all_reports) {
			const aux_keys: any = [];
			categorias_relatorios.map((item: typeKeys) => {
				if (item.isValid) {
					aux_keys.push(item.key);
				}
			});
			dispatch(RelatorioActions.set_current_selected_reports(aux_keys));
		}
	}, [all_reports]);

	return (
		<ContainerDash>
			<Return
				onClick={() => {
					if (emit_type_report === "EVA") {
						dispatch(DashBoardActions.set_current_page("relatorio_pain_map"));
					} else {
						dispatch(DashBoardActions.set_current_page("perfil_paciente"));
					}
					dispatch(RelatorioActions.set_emit_type_report(""));
				}}
			>
				<Icon
					src={ReturnIcon}
					style={{ width: "0.875rem", height: "0.875rem" }}
				/>
				<P3Desk>Informações do paciente</P3Desk>
			</Return>
			<div
				style={{
					display: "flex",
					flexDirection: "row",
					alignItems: "center",
					marginTop: "1rem",
					marginBottom: "3rem",
					width: "60%",
				}}
			>
				<ProfilePicture
					src={patient?.USUARIO_FOTO ? patient?.USUARIO_FOTO : Perfil}
				/>
				<S1Desk style={{ marginLeft: "1rem" }}>{patient.USUARIO_NOME}</S1Desk>
			</div>
			<WhiteContainer style={{ position: "relative" }}>
				<P2Desk style={{ marginBottom: "1rem" }}>
					Selecione quais informações serão geradas no relatório:
				</P2Desk>
				<Option>
					<Checkbox
						style={{ marginRight: "0.5rem" }}
						id={patient.ID_USUARIO.toString()}
						type="checkbox"
						src={CheckboxIcon}
						checked={all_reports}
						onClick={() => {
							set_all_reports(all_reports ? false : true);
							all_reports == true &&
								dispatch(RelatorioActions.set_current_selected_reports([]));
						}}
					/>
					<P2Desk>Relatório completo</P2Desk>
				</Option>
				{filterOptionsForSelect.map((categoria: typeKeys, index) => (
					<Option
						style={categoria.isValid ? { opacity: 1 } : { opacity: 0.3 }}
						key={index}
					>
						<Checkbox
							style={
								categoria.key == "RELATORIO_COMPLETO"
									? { marginRight: "0.5rem" }
									: { marginRight: "0.5rem", marginLeft: "1.5rem" }
							}
							id={patient.ID_USUARIO.toString()}
							type="checkbox"
							src={CheckboxIcon}
							checked={
								current_selected_reports.includes(categoria.key) &&
								categoria.isValid
							}
							onClick={() => {
								categoria.isValid && AddReportSelected(categoria.key);
							}}
						/>
						<P2Desk>{categoria.title}</P2Desk>
					</Option>
				))}
			</WhiteContainer>

			{reportHasLimit ? (
				<div
					style={{
						display: "flex",
						flexDirection: "row",
						alignItems: "center",
						gap: "0.5rem",
						justifyContent: "center",
						backgroundColor: Colors.neutral_grey_k_10,
						padding: "0.5rem",
						borderRadius: "0.5rem",
						color: Colors.neutral_grey_k_70,
						marginBottom: "2rem",
					}}
				>
					<Icon src={Print} style={{ width: "1.25rem", height: "1.25rem" }} />

					<div>
						Consome{" "}
						<span style={{ fontWeight: "bold" }}>1 crédito de {""}</span>
						{checkLimitReport()}
					</div>
				</div>
			) : null}

			<div
				style={{
					width: emit_type_report == "EVA" ? "57%" : "60%",
					position: emit_type_report == "EVA" ? "absolute" : "relative",
					bottom: emit_type_report == "EVA" ? 0 : "undefined",
				}}
			>
				<ButtonSave
					active={current_selected_reports.length > 0 ? true : false}
					onClick={() => {
						if (
							(emit_type_report == "EVA" &&
								current_selected_reports.includes("EVA")) ||
							(current_selected_reports.includes("EVA") &&
								current_selected_reports.length == 1)
						) {
							const per = `0000-00-00/${moment(new Date()).format(
								"YYYY-MM-DD"
							)}`;

							dispatch(RelatorioActions.set_current_selected_period(per));

							dispatch(RelatorioActions.get_emitir_relatorio());
							setLoading(true);
						} else {
							current_selected_reports.length > 0 &&
								dispatch(
									DashBoardActions.set_current_page("selecao_exercicios")
								);
						}
					}}
				>
					{loading ? (
						<CircularProgress
							color="inherit"
							style={{ width: "1.3rem", height: "1.3rem" }}
						/>
					) : emit_type_report == "EVA" ||
					  (current_selected_reports.includes("EVA") &&
							current_selected_reports.length == 1) ? (
						"Gerar Relatório"
					) : (
						"Avançar"
					)}
				</ButtonSave>
				<ButtonSave
					onClick={() => {
						if (emit_type_report === "EVA") {
							dispatch(DashBoardActions.set_current_page("relatorio_pain_map"));
						} else {
							dispatch(DashBoardActions.set_current_page("perfil_paciente"));
						}
						dispatch(RelatorioActions.set_emit_type_report(""));
					}}
					style={{
						marginTop: "1rem",
						marginBottom: "1rem",
						backgroundColor: "transparent",
						pointerEvents: emit_type_report === "EVA" ? "auto" : "none",
						color: emit_type_report === "EVA" ? "#000E4B" : "#aea9b4",
					}}
					active={emit_type_report === "EVA" ? true : false}
				>
					Voltar
				</ButtonSave>
			</div>
		</ContainerDash>
	);
};

const WhiteContainer = styled.div`
	width: 60%;
	margin-bottom: 1rem;
	display: flex;
	flex-direction: column;

	overflow-y: scroll;
	overflow-x: hidden;

	::-webkit-scrollbar {
		width: 2px;
		height: 2px;
	}
	::-webkit-scrollbar-thumb {
		background: #e0e0e0;
		border-radius: 10px;
	}
	::-webkit-scrollbar-track {
		background: #ffffff;
		border-radius: 10px;
	}
`;

const Option = styled.div`
	width: 100%;
	display: flex;
	flex-direction: row;
	align-items: center;

	padding-top: 1rem;
	padding-bottom: 1rem;
	border-bottom: 1px solid var(--Neutras-Grey-K-10, #dedfe3);
`;
export default EmissaoRelatorios;
